import React, { useState, useRef } from 'react';
import ZentorgaForm from '../components/ZentorgaForm';
import SurveyQuestion from '../components/SurveyQuestion';
import SoundVideo from '../components/SoundVideo';
import BenefitPeriod from '../../components/BenefitPeriod';
import { useFormSubmit } from '../hooks/useFormSubmit';
import { getImageArray } from '../utils/templateMapper';
import '../styles/zentorga.scss';
import '../styles/template12.scss';

const Template12 = ({
  landingData,
  urlCode,
  urlCodeSettingId
}) => {
  const { handleSubmit, isSubmitting } = useFormSubmit(
    urlCode,
    urlCodeSettingId,
    landingData.endpoint
  );
  const [surveyAnswer, setSurveyAnswer] = useState('');

  const handleFormSubmit = async (formData) => {
    await handleSubmit({
      ...formData,
      ...(surveyAnswer && { selectedOption: surveyAnswer }),
    });
  };

  const formRef = useRef(null);
  const images = getImageArray(landingData, 6);

  return (
    <section className="template12-layout zentorga-layout">
      {/* 이미지 섹션 */}
      {images.length > 0 && (
        <div className="template12-images zentorga-images">
          {images.map((img, idx) => {
            const fileExtension = img.url.split('.').pop().toLowerCase();
            const isVideo = ['mp4', 'webm', 'ogg', 'mov'].includes(fileExtension);

            return isVideo ? (
              <SoundVideo key={idx} src={img.url} loop={img.alt !== "false"} />
            ) : (
              <img key={idx} src={img.url} alt={img.alt} />
            );
          })}
        </div>
      )}

      {/* 설문 섹션 */}
      {landingData.surveyTitle1 && (
        <div className="surveySection">
          <SurveyQuestion
            topic={landingData.surveyTitle1}
            answers={[
              landingData.surveyOpt1_1,
              landingData.surveyOpt1_2,
              landingData.surveyOpt1_3,
              landingData.surveyOpt1_4,
              landingData.surveyOpt1_5
            ].filter(Boolean)}
            questionNumber={1}
            displayType={landingData.surveyTopic?.topic?.[0]?.type || 'radio'}
            numberColor={landingData.surveyTopic?.numberColor}
            answerColor={landingData.surveyAnswer?.answerColor}
            onChange={setSurveyAnswer}
          />
        </div>
      )}

      {/* 이벤트 대상자 */}
      {landingData.eventTarget && (
        <div className="eventTarget">
          <p>이벤트 대상자 : <span className="event-target-text">{landingData.eventTarget}</span></p>
        </div>
      )}

      {/* 혜택 기간 */}
      {landingData.benefitDate && (
        <div className="benefitDate">
          <BenefitPeriod periodType={landingData.benefitDate} />
        </div>
      )}

      {/* 폼 섹션 */}
      <div className="formStyleClassName">
        <ZentorgaForm
          ref={formRef}
          onSubmit={handleFormSubmit}
          isSubmitting={isSubmitting}
          formStyle={landingData.formStyleClassName || 'gray'}
          consentStyle={landingData.privacyPolicyClassName || 'dark'}
          privacyPolicyName={landingData.privacyPolicyName || '본원'}
          privacyPolicy={landingData.privacyPolicy}
          marketingPolicy={landingData.marketingPolicy}
          buttonComponent={
            <button
              type="button"
              className={`postBtn ${landingData.postBtnLocate === 'fixed' ? 'postBtn-fixed' : ''}`}
              id="postBtn"
              disabled={isSubmitting}
              onClick={() => {
                if (landingData.postBtnLocate === 'fixed') {
                  window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
                }
                formRef.current?.submitForm();  // ← requestSubmit() 대신 직접 호출
              }}
            >
              {landingData.postBtnUrl ? (
                <img src={landingData.postBtnUrl} alt="신청하기" />
              ) : (
                <span>{isSubmitting ? '신청 중...' : '신청하기'}</span>
              )}
            </button>
          }
        />
      </div>

      {/* 서비스 정보 */}
      {landingData.serviceInfoClassName && (
        <p
          className={`serviceInfoClassName ${landingData.serviceInfoClassName}`}
          id="serviceInfoClassName"
        >
          * 본 서비스는 전국 20여 개 이상의 제휴 병원에서 제공되며,<br />
          상담 신청 정보를 기반으로 전문 상담원이 적합한 제휴 병원을 안내해드립니다.
        </p>
      )}

      {/* 푸터 */}
      {landingData.footerClassName !== null && (landingData.footerClassName !== undefined || landingData.footerDetail) && (
        <footer className={`footerClassName ${landingData.footerClassName || ''}`}>
          {landingData.footerDetail && (
            <p className="footerDetail" style={{ whiteSpace: 'pre-line' }}>
              {landingData.footerDetail}
            </p>
          )}
        </footer>
      )}
    </section>
  );
};

export default Template12;
